import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex-direction: column;
`

export const Title = styled.h1`
    font-size: 100px;
    display: block;
    font-weight: 300;
`;

export const Subtitle = styled.h1`
    font-size: 40px;
    display: block;
    font-weight: 300;
`;